import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidOtherSellerTinError extends Violation {
	public constructor() {
		super(ViolationSeverity.Error, 'business.company.validation.other-seller.tax-identification-number-required');
	}
}
